var exports = {
  "$q": "MonaFooterGrid__d-AzKN",
  "rw": "Rect__ywSLM_",
  "zj": "RepositoryPanel__9cDraF",
  "OT": "RepositoryContent__EktZ-q",
  "Ae": "RepositoryName__xhaLfr",
  "hg": "RepositoryDescription__JVXrci",
  "Wd": "RepositoryStars__qa97vZ",
  "_H": "GrayTile__lYkkgV",
  "Mf": "ColorTile__kodRwV",
  "LL": "HoverTile__b5TkKe",
};

module.exports = exports;
